import React, { Fragment, useState } from 'react'
import { Btn, H6, P } from '../../AbstractElements';
import CommonModal from './Common/CommonModal';
import { belowsmData } from '../../Data/UiKits/Modal';

export interface ModalProps {
    isOpen: boolean;
    header?: boolean;
    class?: string;
    footer?: boolean;
    toggle: () => void,
    action: () => void,
    title?: string;
    size?: string;
    bodyClass?: string;
    button?: string;
    center?: boolean;
    children: string | JSX.Element | JSX.Element[],
}

export default function Modal({isOpen, toggle, action, title, size, button, children} : ModalProps) {
    // const [modal, setModal] = useState(false);
    // const toggle = () => { setModal(!modal); }
    const data = {
        isOpen,
        header: true,
        footer: true,
        toggler: toggle,
        action,
        title,
        size,
        class: 'modal-fullscreen-lg-down',
        bodyClass: 'dark-modal',
        button
    }
    return (
        <>
            {/* <Btn color='warning' outline onClick={toggle} >{'Fullscreen below lg'}</Btn> */}
            <CommonModal modalData={data}>
                {children}
            </CommonModal>
        </>
    )
}
